import { useFormContext, useWatch } from 'react-hook-form';
import { useFYIEntities } from '../../../../../../../queries/use-fyi-entities';
import { OnboardingFormData } from './FYIGroupsOnboarding';
import { useEffect, useLayoutEffect } from 'react';
import { Spinner } from '@cimplico/components';
import FYIEntityRow from './FYIEntityRow';

type FYIEntitiesListProps = {
    groupIndex: number;
    disableFetch?: boolean;
    show: boolean;
    onSizeChange: () => void;
};

function FYIEntitiesList({ groupIndex, show, disableFetch = false, onSizeChange }: FYIEntitiesListProps): JSX.Element | null {
    const { control, setValue } = useFormContext<OnboardingFormData>();
    const { group, entities } = useWatch({ name: `data.${groupIndex}`, control });
    const { fyiGroup, isSelected, month, day, monthError, dayError } = group;

    const { isLoading, data: fyiEntities } = useFYIEntities({ group: [fyiGroup.id], showUnmappedEntities: true }, !disableFetch);

    useLayoutEffect(() => {
        onSizeChange();
    }, [entities, show]);

    useEffect(() => {
        if (fyiEntities) {
            setValue(
                `data.${groupIndex}.entities`,
                fyiEntities.map((e) => {
                    const matchingEntity = entities.find((ent) => ent.fyiEntity.id === e.id);
                    return {
                        fyiEntity: e,
                        isSelected,
                        month: matchingEntity?.month || month,
                        day: matchingEntity?.day || day,
                        monthError: matchingEntity?.month ? undefined : monthError,
                        dayError: matchingEntity?.day ? undefined : dayError,
                    };
                })
            );
        }
    }, [fyiEntities]);

    if (!show) {
        return null;
    }

    return (
        <div className="pl-12 mb-3">
            <p className="text-sm text-gray-800 font-medium border-b pb-2">Entities</p>
            {isLoading && (
                <div className="py-2">
                    <Spinner size="sm" />
                </div>
            )}
            {entities.length > 0 && (
                <ul className=" divide-y">
                    {entities.map(({ fyiEntity }, index) => (
                        <FYIEntityRow key={fyiEntity.id} groupIndex={groupIndex} index={index} />
                    ))}
                </ul>
            )}
            {entities.length === 0 && <div className="h-8"></div>}
        </div>
    );
}

export default FYIEntitiesList;
